export const stopPropagation = (event) => {
  event.stopPropagation();
};
